import { Observable } from 'rxjs';
import { Cars } from '../models/cars.model';

export abstract class CarsRepository {
    abstract getCars(): Observable<Cars>;
    abstract getMoreCars(): Observable<Cars>;
}
